import { useStore } from '@tmsw/powerups.store';
import { useCallback } from 'react';

// 3 Stars = 25 to 31 moves
// 2 Stars = 32 to 42 moves
// 1 Star = 43 or more
function useComputeRank() {
  const movesCount = useStore((state) => state.movesCount);
  function computeRank() {
    if (movesCount >= 43) {
      return ['success_01_stars_animation', 'successLevel1', 1];
    } else if (movesCount >= 32 && movesCount <= 42) {
      return ['success_02_stars_animation', 'successLevel2', 2];
    } else {
      return ['success_03_stars_animation', 'successLevel3', 3];
    }
  }

  return useCallback(computeRank, [movesCount]);
}

export default useComputeRank;
